import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ResourceRequestDetailIndicator from '../ResourceRequestDetailIndicator';
import useStyles, { useRequestIndicatorStyles } from './useStyles';

export const ResourceRequestResourceInfo = ({
  classes: classesOverride,
  resourceRequest,
  qeIdTag,
  maxSkillLevel,
  isPsaPraaResourceMatchingEnabled = false
}) => {
  const classes = useStyles({ classes: classesOverride });
  const requestIndicatorClasses = useRequestIndicatorStyles();

  return (
    <div
      data-qe-id={`${resourceRequest.id}_ResourceRequestResourceInfo`}
      className={
        isPsaPraaResourceMatchingEnabled &&
        resourceRequest.isDelaDraftResourceRequest
          ? classes.root2
          : classes.root
      }
    >
      <div className={classes.quantityRow}>
        <span
          className={classes.quantity}
          data-qe-id={
            qeIdTag
              ? `ResourceRequestQuantity_${qeIdTag}`
              : 'ResourceRequestQuantity'
          }
        >
          {resourceRequest.quantity}{' '}
        </span>
        <FormattedMessage id="resourceRequestItem.requested" />
      </div>
      <div className={classes.groupsRow}>
        <ResourceRequestDetailIndicator
          maxSkillLevel={maxSkillLevel}
          resourceRequest={resourceRequest}
          classes={requestIndicatorClasses}
        />
      </div>
    </div>
  );
};

ResourceRequestResourceInfo.propTypes = {
  classes: PropTypes.object,
  resourceRequest: PropTypes.object,
  qeIdTag: PropTypes.string,
  maxSkillLevel: PropTypes.number,
  isPsaPraaResourceMatchingEnabled: PropTypes.bool
};

export default ResourceRequestResourceInfo;
